import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import _ from 'lodash';
import searchMyProjectsClicked from "../../../assets/images/searchMyProjectsClicked.svg";
import searchMyProjects from '../../../assets/images/searchMyProjects.svg';
import ExportSelectedRows from '../../ExportCSV';
import filter from '../../../assets/images/filter.svg';
import BlueFilterIcon from '../../../assets/images/BlueFilterIcon.svg';
import { CustomBreadCrum } from "../../common/CustomBreadcrum";
import WrapIcon from '../../../assets/images/wrap-icon.png';
import ChangeHandling from '.';
import ChangeHandlingHistoryFilter from './ChangeHandlingHistoryFilter';
import './ChangeHandling.scss'; 

const ChangeHandlingHistoryHeader = (props) => {
  const {
    clearFilter,
    onSearchClick,
    allData,
    headers,
    filename,
    selectedRows,
    isFilterEnabled,
    onChildClick,
    historywrapFreeText,
    setHistoryWrapFreeText,
    filterFLag,

  } = props;

  const location = useLocation();
  const [state, updateState] = useState([]);
  const { ProjectID, id } = useParams();
  let currentUrl = '';
  const items = [];
    const [isClicked, setIsClicked] = useState(false);
    const [isfilterClicked, setIsFilterClicked] = useState(false);

  const handleClick = () => {
    const newIsClicked = !isClicked;
    setIsClicked(newIsClicked);
    // For history table: toggle search mode and call onSearchClick (parent will handle filtering logic)
    if (onSearchClick) {
      onSearchClick(newIsClicked);
    }
    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };

  // Filter icon click handler - should clear all column filters
  const handleFilterClick = () => {
    if (isFilterEnabled) {
      if (clearFilter) {
        clearFilter();
      }
      setIsFilterClicked(false);
      if (onChildClick) {
        onChildClick(false); // Notify parent that filters are cleared
      }
    }
  };

  useEffect(() => {
    setIsFilterClicked(isFilterEnabled);
  }, [isFilterEnabled]);

  return (
    <div className="actions-history">
      <div className="action-button-history ">
        <img
          src={WrapIcon}
          alt={historywrapFreeText ? "Unwrap Free Text" : "Wrap Free Text"}
          title={historywrapFreeText ? "Unwrap Free Text Columns" : "Wrap Free Text Columns"}
          onClick={() => setHistoryWrapFreeText((prev) => !prev)}
          className='wrapIconHistory'
          style={{
            filter: historywrapFreeText ? "none" : "grayscale(100%)"
          }}
        />
        <img
          alt="filter"
          hidden={filterFLag}
          onClick={handleFilterClick}
          className={isFilterEnabled ? "header-icons filter-active" : "header-icons filter-inactive"}
          src={isFilterEnabled ? BlueFilterIcon : filter}
          style={{
            cursor: isFilterEnabled ? "pointer" : "default",
            height: "20px",
            marginRight: "8px"
          }}
          title={isFilterEnabled ? "Clear Column Filters" : "No filters applied"}
        />
        
        {/* Search Icon - separate from filter functionality */}
        <img
          src={isClicked ? searchMyProjects : searchMyProjectsClicked}
          alt="search field"
          onClick={handleClick}
          className="header-icons"
          title={isClicked ? "Disable Search" : "Enable Search"}
        />
        {/* Remove local search input, let parent handle search UI and logic as in main screen */}
        <>
          <ExportSelectedRows
            selectedRows={selectedRows}
            allData={allData}
            headers={headers}
            filename={filename}
          />
        </>
      </div>
    </div>
  );
};
export default ChangeHandlingHistoryHeader;
